import { useContext } from 'react'
import UserContext from '../contexts/user'

const useCurrentUserId = (): string | undefined => {
  const { user } = useContext(UserContext)
  return user?.id
}

export default useCurrentUserId;
